import { AxiosError } from 'axios';
import { BaseClient } from '../client';
import { IndicacaoApiResponse, IndicacaoDashboard, IndicacaoFiltros } from './indicacao.types';

export const getIndicacaoDashboard = async (filtros?: IndicacaoFiltros) => {
	try {
		const response = await BaseClient.get<IndicacaoApiResponse<IndicacaoDashboard>>(
			'v2/Indicacao/Dashboard',
			{
				params: {
					data_inicio: filtros?.data_inicio || undefined,
					data_fim: filtros?.data_fim || undefined,
					id_usuario: filtros?.id_usuario || undefined,
				},
			}
		);
		return response.data;
	} catch (error) {
		const axiosError = error as AxiosError<IndicacaoApiResponse<IndicacaoDashboard>>;
		if (axiosError.response?.data?.message) {
			return axiosError.response.data;
		}
		throw error;
	}
};
